import React, { useState, useRef, useEffect, useContext } from 'react';
import ReactGA from "react-ga4";
import style from './rechargepopup.module.css'
import { BsGift, } from 'react-icons/bs';
import { BiBookmarkPlus } from "react-icons/bi";
import { FaUserFriends } from "react-icons/fa";
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
import { FaArrowRight } from "react-icons/fa";
import {
    fetchPaymentSecretStripe,
    fetchPriceStripe,
    fetchPriceStripeUSD,
    getUserInfo,
    reedemCode,
    queryGroupInfo
} from '../../../utils/net';
import {
    isFeedbackModalOpenAtom,
    showHistoryAtom,
    openPaymentInfoAtom,
    showSubscribeAtom,
    showReferralAtom,
    balanceAtom, iframeAtom,
    subscriptionsInfoAtom, subscriptionsPreInfoAtom, showSubscribeTimesAtom, logInfoAtom
} from '../../../store';
import { useTips } from '../../../common/GlobalTips';
import ARROW from './assets/arrow.png'
import * as Sentry from "@sentry/react";
import { useTranslation } from "react-i18next";
import { useLocation } from 'react-router-dom';
import { trackEvent } from '../../../utils/trackEvent'
import { PermissionContext } from '../../../utils/context';


const PaymentHomePage = ({ handleClose, handlePaymentMethodChange, setIsFeedbackModalOpen }) => {
    const setShowHistory = useSetRecoilState(showHistoryAtom)
    const [, setYearChecked] = useRecoilState(showSubscribeTimesAtom)
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const subscriptionsInfo = useRecoilValue(subscriptionsInfoAtom);
    const subscriptionsPreInfo = useRecoilValue(subscriptionsPreInfoAtom)
    const setShowSubscribe = useSetRecoilState(showSubscribeAtom)
    const setShowReferral = useSetRecoilState(showReferralAtom)
    const logInfo = useRecoilValue(logInfoAtom)
    const locating = useLocation();
    const [creditsHover, setCreditsHover] = useState(false)
    const [subHover, setSubHover] = useState(false)
    const [customStep, setCustomStep] = useState(1)
    const [changePrice, setChangePrice] = useState(0)
    const { t } = useTranslation();
    const tip = useTips();
    const priceRef = useRef()
    const arrowRef = useRef()
    const customRef = useRef(null)
    const setIframe = useSetRecoilState(iframeAtom)
    const { isCreatorOrAbove } = useContext(PermissionContext);

    useEffect(() => {
        if (!openPaymentInfo.state) {
            setCustomStep(1)
            setChangePrice(0)
            priceRef.current.value = ''
        }
    }, [openPaymentInfo.state])

    const handlerToSubscribe = () => {
        ReactGA.event(
            {
                category: 'ui_click',
                action: 'open_subscribe',
                label: 'header.recharge_popup'
            }
        )
        setShowSubscribe(true)
        setOpenPaymentInfo(pre => {
            return {
                ...pre,
                state: false
            }
        })
    }

    const handlerToBusSubscribe = () => {
        trackEvent('Subscribe - Page: Open')
        setYearChecked('monthly')
        ReactGA.event(
            {
                category: 'ui_click',
                action: 'open_subscribe',
                label: 'header.recharge_popup'
            }
        )
        setShowSubscribe(true)
        setOpenPaymentInfo(pre => {
            return {
                ...pre,
                state: false
            }
        })
    }

    const handlerToReferral = () => {
        // tip({
        //     type: 'primary',
        //     content: 'Coming soon!',
        // });
        // try {
        //     window.history.pushState(
        //         { page: "referral" },
        //         "Referral Page",
        //         "/referral"
        //         );
        // } catch (e) {
        //     Sentry.captureException(e)
        //     console.error(e)
        // }
        trackEvent('Referral - Page: Open')
        setShowReferral(true)
        setOpenPaymentInfo(pre => {
            return {
                ...pre,
                state: false
            }
        })
    }

    const handleGetRedeem = () => {
        _czc.push(['_trackEvent', 'Pop Up', 'Get Redeem', 'Top Up Panel']);
        trackEvent('Redeem Code - Get - Page: Open')
        window.open(
            'https://forms.office.com/Pages/ResponsePage.aspx?id=DQSIkWdsW0yxEjajBLZtrQAAAAAAAAAAAANAAUIQFilUNjNGM0NLUUhEUEkxVlRFTkw0OVA3NzlVNS4u',
        );
    };

    const handlerRefund = () => {

        ReactGA.event(
            {
                category: 'ui_click',
                action: 'refund_request',
                label: 'header.recharge_popup'
            }
        )
        trackEvent('Feedback: Open')
        setOpenPaymentInfo({
            balance: "",
            state: false,  //open close payment 
            group: false,
            type: 'Personal', // `Personal` : 'Group'
            payMethod: 'Stripe', //Alipay  Stripe Code
            step: 1  // 0-home , 1-balance , 2-confirm , 3-success , 4-coderedeem 
        })
        setIsFeedbackModalOpen(true)
        // setShowIframePopup('Refund')
    }

    const safeConvertCurrencyCents = (n) => {
        const padded_n = String(n);
        return padded_n.slice(0, -2) + '.' + padded_n.slice(-2);
    }

    const handleAmountCheck = async (amount) => {
        if ((!priceRef.current.value && amount > 0) || (priceRef.current.value && amount > 24)) {
            handlePaymentMethodChange('Stripe')
            const inputValue = parseFloat(amount);
            const roundedValue = isNaN(inputValue) ? '0' : inputValue <= 0 ? "1" : Number(inputValue.toFixed(2)).toString();
            setOpenPaymentInfo({
                ...openPaymentInfo,
                balance: roundedValue
            })
            const price = await fetchPriceStripe(Math.round(roundedValue * 10));

            if (price) {
                trackEvent('Header - Wallet - Payment: Check', { payAmount:amount })
                try {
                    const param = { token_amount: Math.round(roundedValue * 10) }
                    if (openPaymentInfo.group) {
                        param.group_uuid = localStorage.getItem('group_uuid')
                    }
                    if (openPaymentInfo.payMethod === 'Stripe') {
                        let secret = await fetchPaymentSecretStripe(param)
                        window.location.href = new URL("/payment?" + "payment_amount=" + safeConvertCurrencyCents(price.data.currency_usd_cents) + "&token_amount=" + price.data.token_amount + "&stripe_secret=" + secret.data.stripe_payment_intents_client_secret, window.location.href).href
                    }
                    handleClose();
                } catch (e) {
                    trackEvent('Header - Wallet - Payment: Error', { payAmount:amount })
                    Sentry.captureException(e)
                    tip({
                        type: 'error',
                        content: `${t('TIP_ERR_RECHPOP_FETCH_URL')}${e.message}`,
                    });
                }
            }
        } else {
            tip({
                type: 'warning',
                content: t('TIP_WRAN_RECHPOP_MORE_CREDITS'),

            });
        }


    };

    const handleChangeCredit = () => {
        // if(customStep===1){
        //     setCustomStep(2)
        // }
        if (customStep === 2) {
            setCustomStep(3)
            priceRef.current.focus()

        }
        // if(customStep===3){
        //     setCustomStep(1)
        // }
    }

    const handleHoverCredit = () => {

        if (customStep === 1) {
            setCustomStep(2)
        }
    }

    const handleLeaveCredit = () => {
        if (customStep === 2) {
            setCustomStep(1)
        }
    }

    const handlePrice = (e) => {
        if (e.target.value) {
            e.target.value = e.target.value.replace(/\D/g, '')
            setChangePrice(e.target.value.replace(/\D/g, ''))
            const usd = Number(e.target.value.replace(/\D/g, '')) * 1.5
            if (usd.toString().length + 1 > 8) {
                arrowRef.current.style.transform = 'scale(0.8) translateY(-0.5rem)'
            } else {
                arrowRef.current.style.transform = 'scale(1)'
                arrowRef.current.style.transform = 'translateY(0)'
            }
        } else {
            setChangePrice(0)
        }

    }
    const creatorPrice = '~120 Assets'
    return (
        <div className={style.step1} onClick={(e) => {
            if (customRef.current.contains(e.target)) {
                return
            } else {
                setCustomStep(1)
                setCustomStep(1)
                setChangePrice(0)
                priceRef.current.value = ''
            }
        }}>
            <div className={`${(!localStorage.getItem('defaultI18n') || localStorage.getItem('defaultI18n') === 'en' || localStorage.getItem('defaultI18n') === 'de') ? style.popupHistory : localStorage.getItem('defaultI18n') === 'zh' ? style.popupHistoryC : style.popupHistoryO}`}>
                <h2>{t('WALLET_POPUP_HEADER_1')}</h2>
                <div className={`${style.subText} text-[rgba(160,160,160,1)]`}><div className={`text-[rgba(169, 126, 255, 1)]`} onClick={handlerToSubscribe}>{t('WALLET_POPUP_HEADER_2')}</div> {t('WALLET_POPUP_HEADER_3')}.</div>
                <div className={`${style.subText} text-[rgba(160,160,160,1)]`}><div className={`text-[rgba(169, 126, 255, 1)]`} onClick={handlerToReferral}>{t('WALLET_POPUP_HEADER_4')}</div> {t('WALLET_POPUP_HEADER_5')}.</div>
                <span
                    className={`${style.historyTitle} hover:text-[var(--redeemBtnHoverColor)]`}
                    onClick={() => {
                        trackEvent('Wallet - History: Open')
                        setShowHistory(true)
                    }}
                >
                    {t('WALLET_POPUP_HEADER_HIS')}
                </span>
            </div>

            <div className={style.paymentMethods}>
                <div className={style.credit}>
                    {['8', '16', '32'].map((coin, index) => {
                        return (
                            <div key={index} className={`group ${style.coin} bg-[rgba(255,255,255,0.05)] text-[rgba(255,255,255,0.9)]`} onMouseEnter={() => { setCreditsHover(coin) }} onMouseLeave={() => setCreditsHover(false)} onClick={() => { handleAmountCheck(Number(coin)) }}>
                                <span>{coin}</span>
                                <span className={`text-[rgba(255,255,255,0.5)]`}>{t('WALLET_CREDITS')}</span>
                                {creditsHover && creditsHover === coin && <div className={style.price}>{`$${Number(creditsHover) * 1.5}`}</div>}
                            </div>
                        )
                    })}
                    <div ref={customRef} className={`${style.customized} bg-[rgba(255,255,255,0.05)] text-[rgba(255,255,255,0.9)] ${customStep === 2 ? style.step2 : ''} ${customStep === 3 ? style.step3 : ''}`} onClick={handleChangeCredit} onMouseEnter={handleHoverCredit} onMouseLeave={handleLeaveCredit}>
                        <div className={style.customStep1} style={{ opacity: customStep === 1 ? '1' : '0', zIndex: customStep === 1 ? '1' : '-1' }}>{t('WALLET_CUSTOMIZED')}</div>
                        <input className={style.customStep2} style={{ opacity: customStep === 2 ? '1' : '0', zIndex: customStep === 2 ? '1' : '-1' }} defaultValue={'> 24 ' + t('WALLET_CREDITS')}></input>
                        <div className={style.customStep3} style={{ opacity: customStep === 3 ? '1' : '0', zIndex: customStep === 3 ? '1' : '-1' }}>
                            <div className={style.stepFont}>
                                <input style={{ transform: changePrice > 0 ? 'translateY(-0.5rem)' : '', marginLeft: changePrice.toString().charAt(0) === '1' ? '-0.4rem' : '' }} value={changePrice === 0 ? '' : changePrice} ref={priceRef} onChange={handlePrice} />
                                <span style={{ transform: changePrice > 0 ? 'translateY(1rem)' : '', opacity: changePrice > 0 ? '1' : '0' }}>{`$${changePrice * 1.5}`}</span>
                            </div>
                            <div ref={arrowRef} className={style.stepDone} onClick={() => { handleAmountCheck(changePrice) }}><span><img src={ARROW} alt='arrow' /></span></div>
                        </div>
                    </div>
                </div>
                {[
                    {
                        component: <BiBookmarkPlus size={24} />,
                        handlerFunc: () => handlerToSubscribe(),
                        name: t('WALLET_POPUP_SUB_TITLE'),
                        id: 'Subscription'
                    },

                    {
                        component: <BsGift size={24} />,
                        handlerFunc: () => {
                            ReactGA.event(
                                {
                                    category: 'ui_click',
                                    action: 'code_redeem',
                                    label: 'header.recharge_popup'
                                }
                            )
                            handlePaymentMethodChange('Code')
                        },
                        name: t('WALLET_POPUP_CODE_TITLE'),
                        id: 'Code Redemption'
                    },
                    {
                        component: <FaUserFriends size={24} />,
                        handlerFunc: handlerToReferral,
                        name: t('WALLET_POPUP_REF_TITLE'),
                        id: 'Refer for FREE Credits'
                    },
                    {
                        handlerFunc: handleGetRedeem,
                        name: t('WALLET_POPUP_SIDE_TITLE_1'),
                        id: 'Looking for redeem code'
                    }, {
                        handlerFunc: handlerRefund,
                        name: t('WALLET_POPUP_SIDE_TITLE_2'),
                        id: 'Need a refund'
                    }
                ].map((item, index) => <button
                    className={`${item?.component ? `${style.popupBtn} hover:bg-[var(--noResultBg)]` : `${style.getRedeemBtn} hover:text-[var(--redeemBtnHoverColor)]`} ${index === 0 ? style.subscribeBtn : ""} ${item.id === 'Subscription' || item.id === 'Code Redemption' || item.id === 'Refer for FREE Credits' || item.id === 'API Dashboard' ? style.popupboder : ""}`}
                    onClick={index === 0 ? () => { } : item.handlerFunc}
                    key={item.id}
                >
                    {item?.component ? <div className={`${style.popupSpan}`} >
                        {item.component}
                        {item.name}
                    </div> :
                        <span className={`after:[background:var(--redeemBtnHoverColor)]`}> {item.name}</span>}

                    {index === 0 && <div className='flex flex-row justify-between w-full mt-[0.4rem] gap-2'>
                        <div className={`group relative w-1/2  before:font-[Arial] before:z-[999]  before:text-white before:font-bold before:absolute before:w-[70%] before:h-[1.3rem] before:[background:linear-gradient(135deg,_#2798D5_10%,_#8E6AFF_45%,#A93BFF_100%)] before:left-[1.2rem] before:-top-2 before:rounded before:flex before:items-center before:justify-center
                         ${subHover === 'creator' ? `before:content-["~60_Assets"] before:text-xs` : 'before:content-["Save_33%"] before:text-[0.8rem]'}`} onClick={item.handlerFunc} onMouseEnter={() => { setSubHover('creator') }} onMouseLeave={() => { setSubHover(false) }}>
                            <div className={`h-[4.6rem] rounded-tl-lg rounded-tr-lg bg-[#373737] font-[Arial] flex relative flex-col gap-[0.2rem] [transition:all_0.2s_ease]
                            group-hover:bg-[#222222] group-hover:cursor-pointer group-hover:after:content-[""] group-hover:after:absolute group-hover:after:w-4/5 group-hover:after:h-px group-hover:after:bg-[rgba(168,_168,_168,0.2)] group-hover:after:bottom-0 group-hover:after:left-[10%]`}>
                                <div className={`flex flex-row items-end justify-center gap-2 relative ${subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 ? 'mt-[1.4rem]' : 'mt-[1.8rem]'}`} >
                                    <span className={`font-bold text-white text-[28px] leading-7 flex items-end relative
                                     after:text-[0.6rem] after:font-[Arial] after:text-[#A9A9A9] after:absolute  after:-top-2 after:[transition:content_3s_ease]
                                    ${subHover === 'creator' ? "after:content-['credits'] after:-right-8" : "after:content-['$'] after:-right-2"}`}>{subHover === 'creator' ? 30 : 24}</span>
                                    <span className='font-[Arial] text-xs text-[#A9A9A9]'>/ {t('SUBSCRIPTION_MONTH')}</span>
                                </div>
                                {subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && <div className='font-[Arial] text-[11px] leading-[11px] font-bold relative bg-[linear-gradient(90deg,_#FB6420_50%,_#F8A730_100%)] bg-clip-text text-transparent'>7-DAY FREE TRIAL</div>}
                            </div>
                            <div className={`rounded-bl-lg rounded-br-lg text-[0.9rem] font-bold text-[#A9A9A9] h-8 flex justify-center items-center bg-[rgb(34,34,34)]`}>
                                {t('SUBSCRIPTION_PLAN_CREATOR')}
                            </div>
                        </div>
                        <div className={`group relative w-1/2 before:font-[Arial] before:z-[999]  before:text-white before:font-bold before:absolute before:w-[70%] before:h-[1.3rem] before:[background:linear-gradient(135deg,_#2798D5_10%,_#8E6AFF_45%,#A93BFF_100%)] before:left-[1.2rem] before:-top-2 before:rounded before:flex before:items-center before:justify-center
                         ${subHover === 'business' ? ((!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 'before:content-["~416_Assets"] before:text-xs' : 'before:content-["~416_Assets"] before:text-xs') : ((!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 'before:content-["Save_82%"] before:text-[0.8rem]' : 'before:content-["Save_66%"] before:text-[0.8rem]')}`}
                            onClick={(!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? handlerToBusSubscribe : item.handlerFunc} onMouseEnter={() => { setSubHover('business') }} onMouseLeave={() => { setSubHover(false) }}>
                            <div className={`h-[4.6rem] rounded-tl-lg rounded-tr-lg bg-[#373737] font-[Arial] flex relative flex-col gap-[0.2rem] [transition:all_0.2s_ease]
                            group-hover:bg-[#222222] group-hover:cursor-pointer group-hover:after:content-[""] group-hover:after:absolute group-hover:after:w-4/5 group-hover:after:h-px group-hover:after:bg-[rgba(168,_168,_168,0.2)] group-hover:after:bottom-0 group-hover:after:left-[10%]`}>
                                <div className={`flex flex-row items-end justify-center gap-2 relative ${(!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 'mt-[1.4rem]' : 'mt-[1.8rem]'}`} >
                                    <span className={`font-bold text-white text-[28px] leading-7 flex items-end relative
                                     after:text-[0.6rem] after:font-[Arial] after:text-[#A9A9A9] after:absolute  after:-top-2 after:[transition:content_3s_ease]
                                    ${subHover === 'business' ? "after:content-['credits'] after:-right-8" : "after:content-['$'] after:-right-2"}`}>{subHover === 'business' ? 208 : (!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 ? 60 : 96}</span>
                                    <span className='font-[Arial] text-xs text-[#A9A9A9]'>/ {t('SUBSCRIPTION_MONTH')}</span>
                                </div>
                                {(!isCreatorOrAbove()) && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Business').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Creator').length === 0 && subscriptionsPreInfo.filter(sub => sub.plan_level === 'Education').length === 0 && <div className='font-[Arial] text-[11px] leading-[11px] font-bold relative bg-[linear-gradient(90deg,_#FB6420_50%,_#F8A730_100%)] bg-clip-text text-transparent'>50%-OFF FIRST MO</div>}
                            </div>
                            <div className={`rounded-bl-lg rounded-br-lg text-[0.9rem] font-bold text-[#A9A9A9] h-8 flex justify-center items-centerbg-[rgb(34,34,34)] `}>
                                {t('SUBSCRIPTION_PLAN_BUSINESS')}
                            </div>
                        </div>
                        <div className='relative w-1/2 h-[6.6rem] flex flex-col justify-between' onClick={item.handlerFunc}>
                            <div className={`h-[48%] rounded-lg font-[Arial] flex relative flex-col gap-[0.2rem] [transition:all_0.2s_ease] bg-[rgb(55,55,55)]
                            hover:bg-[#222222] hover:cursor-pointer`}>
                                <div className='flex flex-row  justify-center  relative mt-[0.6rem] gap-[0.2rem] items-center'>
                                    <span className={`font-bold text-base leading-4 flex items-end relative text-white`}>{t('SUBSCRIPTION_PLAN_EDUCATION')} </span><FaArrowRight color='#ffffff' />
                                </div>
                                <div className='font-[Arial] text-xs leading-3 font-bold relative bg-[linear-gradient(45deg,_#A0D1FF_15%,_#C099FF_80%)] bg-clip-text text-transparent mt-[0.1rem]'>
                                    <span className='font-bold -left-2 text-sm relative text-[rgba(214,214,214,0.7)] after:text-[0.5rem] after:font-[Arial] after:text-[#A9A9A9] after:absolute after:-top-1 after:content-["$"] after:-right-[0.35rem]'>12</span>
                                    <span className={`absolute line-through text-[rgba(214,214,214,0.7)] decoration-white`}>24</span>
                                    <span className='font-[Arial] text-xs text-[#A9A9A9] ml-4'>/ {t('SUBSCRIPTION_MONTH')}</span>
                                </div>
                            </div>
                            <div className={`h-[48%] rounded-lg font-[Arial] flex relative flex-col gap-[0.2rem] [transition:all_0.2s_ease] bg-[rgb(55,55,55)]
                            hover:bg-[#222222] hover:cursor-pointer`}>
                                <div className='flex flex-row  justify-center  relative mt-[0.6rem] gap-[0.2rem] items-center'>
                                    <span className={`font-bold text-base leading-4 flex items-end relativetext-white`}>{t('SUBSCRIPTION_LET_TALK')} </span><FaArrowRight color='#ffffff' />
                                </div>
                                <div className='font-[Arial] text-xs leading-3 font-bold relative bg-[linear-gradient(45deg,_#A0D1FF_15%,_#C099FF_80%)] bg-clip-text text-transparent mt-[0.1rem]'>API / SDK</div>
                            </div>
                        </div>
                    </div>}
                </button>)}
            </div>
        </div>
    )
}

const PaymentBalancePage = ({ handleBack, currency, setPaymentAmount, setCurrency }) => {

    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const tip = useTips();
    const { t } = useTranslation();
    const handleAmountChange = (event) => {
        const inputValue = parseFloat(event.target.value);
        const roundedValue = isNaN(inputValue) ? '0' : inputValue <= 0 ? "1" : Number(inputValue.toFixed(2)).toString();
        setOpenPaymentInfo({
            ...openPaymentInfo,
            balance: roundedValue
        })
    };

    const handleNext = async () => {
        if (openPaymentInfo.balance) {
            try {
                let price = '';
                setPaymentAmount(0);

                if (openPaymentInfo.payMethod === 'Stripe') {
                    try {
                        if (currency === 'USD') {
                            price = await fetchPriceStripeUSD(Math.round(openPaymentInfo.balance * 100));
                        } else {
                            price = await fetchPriceStripe(Math.round(openPaymentInfo.balance * 10));
                        }
                        setPaymentAmount(price.data.currency_usd_cents);
                        setOpenPaymentInfo({
                            ...openPaymentInfo,
                            balance: price.data.token_amount / 10,
                            step: openPaymentInfo.step + 1
                        })
                    } catch (error) {
                        Sentry.captureException(error)
                    }
                }
            } catch (e) {
                Sentry.captureException(e)
                tip({
                    type: 'error',
                    content: `${t('TIP_ERR_RECHPOP_FETCH_URL')}${e.message}`,
                });
            }
        }
    };

    const handleCurrencyChange = (event) => {
        setCurrency(event.target.value);
    };

    return (
        <div className={style.step2}>
            <h2>Top Up Amount</h2>
            <span className={style.exchangeRate}>{openPaymentInfo.exchangeRateMap[openPaymentInfo.payMethod]}</span>
            <div className={style.inputContainer}>
                <input
                    className={style.popupInput}
                    type="number"
                    min="1"
                    step="1"
                    value={openPaymentInfo.balance}
                    onChange={handleAmountChange}
                    placeholder="Amount"
                />
                <select
                    className={style.popupSelect}
                    value={currency}
                    onChange={handleCurrencyChange}
                >
                    <option value="CREDITS">CREDITS</option>
                    <option value={openPaymentInfo.payMap[openPaymentInfo.payMethod]}>{openPaymentInfo.payMap[openPaymentInfo.payMethod]}</option>
                </select>
            </div>
            <button className={style.popupBtn} onClick={handleNext}>
                Next Step
            </button>
            <button className={style.popupBtn} onClick={handleBack}>
                Back
            </button>
        </div>
    )

}

const PaymentConfirmPage = ({ handleClose, currency, paymentAmount }) => {
    const tip = useTips();
    const { t } = useTranslation();
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const setShowSubscribe = useSetRecoilState(showSubscribeAtom)

    const handlePaymentFailure = () => {
        handleClose();
    };

    const handlePaymentConfirmed = async () => {
        try {
            const param = { token_amount: Math.round(openPaymentInfo.balance * 10) }
            if (openPaymentInfo.group) {
                param.group_uuid = localStorage.getItem('group_uuid')
            }
            if (openPaymentInfo.payMethod === 'Stripe') {
                let secret = await fetchPaymentSecretStripe(param)
                window.location.href = new URL("/payment?" + "payment_amount=" + parseFloat(paymentAmount) / 100 + "&token_amount=" + Math.round(openPaymentInfo.balance * 10) + "&stripe_secret=" + secret.data.stripe_payment_intents_client_secret, window.location.href).href
            }

            handleClose();
        } catch (e) {
            Sentry.captureException(e)
            tip({
                type: 'error',
                content: `${t('TIP_ERR_RECHPOP_FETCH_URL')}${e.message}`,
            });
        }
    };

    const handlerToSubscribe = () => {

        setShowSubscribe(true)
        setOpenPaymentInfo(pre => {
            return {
                ...pre,
                state: false
            }
        })
    }

    const SubscribeDialog = () => {
        return (
            <div className={style.step3}>

                {currency === 'CREDITS' && (
                    <h2>
                        Price for
                        {' '}
                        {Math.round(openPaymentInfo.balance)}
                        {' '}
                        credits is
                        {' '}
                        {parseFloat(paymentAmount) / 100}
                        {' '}
                        {openPaymentInfo.payMap[openPaymentInfo.payMethod]}
                        .
                    </h2>
                )}
                {(currency === 'USD' || currency === 'CNY') && (
                    <h2>
                        You will get
                        {' '}
                        {openPaymentInfo.balance}
                        {' '}
                        credits for
                        {' '}
                        {parseFloat(paymentAmount) / 100}
                        {' '}
                        {openPaymentInfo.payMap[openPaymentInfo.payMethod]}
                        .
                    </h2>
                )}

                <div className={style.subscribing}>Catch more savings by <span className={style.subbscribeNow} onClick={handlerToSubscribe}> subscribing now</span>.
                    <br />
                    <div className={style.freeTrial}>(7-days free trial)</div>
                </div>


                <button
                    className={style.popupBtn}
                    onClick={handlePaymentConfirmed}
                >
                    Continue to pay
                </button>
                <button
                    className={style.popupBtn}
                    onClick={handlePaymentFailure}
                >
                    Back
                </button>
            </div>
        )
    }

    const NormalDialog = () => {
        return (
            <div className={style.step3}>
                {currency === 'CREDITS' && (
                    <h2>
                        Price for
                        {' '}
                        {Math.round(openPaymentInfo.balance)}
                        {' '}
                        credits is
                        {' '}
                        {parseFloat(paymentAmount) / 100}
                        {' '}
                        {openPaymentInfo.payMap[openPaymentInfo.payMethod]}
                        .
                    </h2>
                )}
                {(currency === 'USD' || currency === 'CNY') && (
                    <h2>
                        You will get
                        {' '}
                        {openPaymentInfo.balance}
                        {' '}
                        credits for
                        {' '}
                        {parseFloat(paymentAmount) / 100}
                        {' '}
                        {openPaymentInfo.payMap[openPaymentInfo.payMethod]}
                        .
                    </h2>
                )}
                <p>Continue?</p>

                <button
                    className={style.popupBtn}
                    onClick={handlePaymentConfirmed}
                >
                    Yes
                </button>
                <button
                    className={style.popupBtn}
                    onClick={handlePaymentFailure}
                >
                    No
                </button>
            </div>
        )
    }


    return (
        openPaymentInfo.balance >= 30 ? <SubscribeDialog /> : <NormalDialog />
    )
}

const PaymentSuccessPage = ({ handleClose }) => {
    return (
        <div className={style.step3}>
            <h2>Top Up Success, thanks.</h2>
            <button className={style.popupBtn} onClick={handleClose}>
                Back
            </button>
        </div>
    )
}

const CodeRedeemPage = ({ handleClose }) => {

    const balance = useRecoilValue(balanceAtom);
    const [inputError, setInputError] = useState(false);
    const setBalance = useSetRecoilState(balanceAtom);
    const [code, setCode] = useState('');
    const tip = useTips();
    const [openPaymentInfo,] = useRecoilState(openPaymentInfoAtom)
    const { t } = useTranslation();

    const handleRedeem = async () => {
        _czc.push(['_trackEvent', 'Pop Up', 'Redeem', 'Top Up Panel']);
        try {
            const param = { code: code }
            if (openPaymentInfo.group) {
                param.group_uuid = localStorage.getItem('group_uuid')
            }
            const res = await reedemCode(param);
            if (!res.data.error) {
                // let newInfo, codeVal
                // const userBalance = balance.selfBalance
                // const groupBalance = balance.groupBalance
                // if (openPaymentInfo.group) {
                //     newInfo = (await queryGroupInfo(localStorage.getItem('group_uuid'))).data;
                //     codeVal = newInfo.balance - groupBalance
                //     setBalance(pre => {
                //         return {
                //             ...pre,
                //             groupBalance: newInfo.balance
                //         }
                //     })
                // } else {
                //     newInfo = (await getUserInfo({})).data;
                //     if (newInfo.error === "NO_SUCH_USER") {
                //         localStorage.setItem('user_uuid', '');
                //         localStorage.setItem('privileged', '')
                //         localStorage.setItem('token', '');
                //         localStorage.setItem('group_uuid', '');
                //         window.location.href = location.pathname;
                //     }
                //     codeVal = newInfo.meta.balance - userBalance;
                //     setBalance(pre => {
                //         return {
                //             ...pre,
                //             selfBalance: newInfo.meta.balance
                //         }
                //     })

                // }
                if (res.data?.effects) {
                    trackEvent('Code Redemption: Success')
                    if (res.data.effects?.AddToUserBalance?.amount) {
                        const codeVal = res.data.effects.AddToUserBalance.amount
                        tip({
                            type: 'success',
                            content: `${t('TIP_SUCCESS_REDEMPTION')} ${codeVal / 10} ${t('TIP_SUCCESS_CREDITS_REDEEMED')}`,
                        })
                    }
                    if (res.data.effects?.AddUserWithPrivilege?.privilege) {
                        tip({
                            type: 'success',
                            content: `${res.data.effects.AddUserWithPrivilege.privilege}`,
                        })
                    }
                    if (res.data.effects?.AddUserWithSubscription) {
                        let utcTime = res.data.effects.AddUserWithSubscription?.expire_time;
                        let date = new Date(utcTime);
                        tip({
                            type: 'success',
                            content: `${t('TIP_SUCCESS_REDEMPTION')} ${res.data.effects.AddUserWithSubscription?.plan_level} ${t('TIP_SUCCESS_REDEMPTION_TIP_1')}, ${t('TIP_SUCCESS_REDEMPTION_TIP_2')} ${res.data.effects.AddUserWithSubscription?.plan_monthly_price} ${t('TIP_SUCCESS_REDEMPTION_TIP_2_1')}, ${t('TIP_SUCCESS_REDEMPTION_TIP_3')} ${date}.`,
                        })
                    }
                }
                // tip({
                //     type: 'success',
                //     content: `${t('TIP_SUCCESS_REDEMPTION')} ${codeVal / 10} ${t('TIP_SUCCESS_CREDITS_REDEEMED')}`,
                // })
                setCode(``);
            }
            if (res.data.error) {
                throw new Error(res.data.error);
            }
        } catch (e) {
            // Sentry.captureException(e)
            if (e.message === 'CODE_NOT_EXIST') {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_RECHPOP_CODE_NOT_EXIST'),
                })
                setInputError(true)
                setCode('')
                setTimeout(() => {
                    setInputError(false)
                }, 1500);
            } else if (e.message === 'USER_ALREADY_REDEEMED_PUBLIC_CODE') {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_RECHPOP_EXIST_REDEEMED_CODE'),
                })
                setInputError(true)
                setCode('')
                setTimeout(() => {
                    setInputError(false)
                }, 1500);
            }
            if (e.message === 'USER_ALREADY_REDEEMED_PUBLIC_CODE') {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_RECHPOP_REDEEMED_CODE'),
                })
                setInputError(true)
                setCode('')
                setTimeout(() => {
                    setInputError(false)
                }, 1500);
            }
            if (e.message === 'USER_NOT_IN_WHITE_LIST') {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_RECHPOP_WHITE_LIST'),
                })
                setInputError(true)
                setCode('')
                setTimeout(() => {
                    setInputError(false)
                }, 1500);
            }
            if (e.message === 'MAX_REDEMPTION_REACHED') {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_RECHPOP_MAX_REDEMPTION'),
                })
                setInputError(true)
                setCode('')
                setTimeout(() => {
                    setInputError(false)
                }, 1500);
            }
            if (e.message === 'CODE_EXPIRED') {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_RECHPOP_CODE_EXPIRED'),
                })
                setInputError(true)
                setCode('')
                setTimeout(() => {
                    setInputError(false)
                }, 1500);
            }
            if (e.message === 'CODE_EXPIRED_OR_NOT_ACTIVATED') {
                tip({
                    type: 'error',
                    content: t('TIP_ERR_RECHPOP_CODE_EXPIRED_OR_NOT_ACTIVATED'),
                })
                setInputError(true)
                setCode('')
                setTimeout(() => {
                    setInputError(false)
                }, 1500);
            }
        }
    };

    const handleCodeChange = (event) => {
        setCode(event.target.value);
    };

    return (
        <>
            <div className={style.step1}>
                <h2>{t('WALLET_CODE_REDEMPTION_TITLE')}</h2>
                <div className={style.inputContainer}>
                    <input
                        className={`${style.popupInput} ${inputError ? style.inputError : ''}`}
                        value={code}
                        onChange={handleCodeChange}
                        placeholder="Code"
                    />
                </div>
                <button className={style.popupBtn} onClick={handleRedeem}>
                    {t('WALLET_CODE_REDEMPTION_BTN_1')}
                </button>
                <button className={style.popupBtn} onClick={handleClose}>
                    {t('WALLET_CODE_REDEMPTION_BTN_2')}
                </button>
            </div>
        </>
    )
}

const RechargePopup = React.memo(React.forwardRef((props, ref) => {
    const setIsFeedbackModalOpen = useSetRecoilState(isFeedbackModalOpenAtom);
    const [openPaymentInfo, setOpenPaymentInfo] = useRecoilState(openPaymentInfoAtom)
    const [currency, setCurrency] = useState('CREDITS');
    const [paymentAmount, setPaymentAmount] = useState('');
    const locating = useLocation();

    const handleClose = () => {
        setOpenPaymentInfo({
            ...openPaymentInfo,
            balance: "",
            step: 1
        })
        setCurrency('CREDITS');
        setPaymentAmount(0);
    };

    const handleBack = async () => {
        setOpenPaymentInfo({
            ...openPaymentInfo,
            step: openPaymentInfo.step - 1
        })
    };


    const handlePaymentMethodChange = (method) => {
        setCurrency('CREDITS');
        if (method === 'Stripe') {
            _czc.push(['_trackEvent', 'Pop Up', 'Stripe', 'Top Up Panel']);
        } else {
            _czc.push(['_trackEvent', 'Pop Up', 'Redemption', 'Top Up Panel']);
        }

        if (method === 'Code') {
            setOpenPaymentInfo({
                ...openPaymentInfo,
                payMethod: method,
                step: 5
            })
        } else {
            setOpenPaymentInfo({
                ...openPaymentInfo,
                payMethod: method,
                step: openPaymentInfo.step + 1
            })
        }
    };

    return (
        <div className={`${style.rechargePopupPosition} bg-[var(--topUpBg)]`} ref={ref} onMouseLeave={() => {
            setOpenPaymentInfo({
                ...openPaymentInfo,
                state: false
            })
        }}>
            <div className={style.rechargePopupBox} id="rechargePopup" >
                {openPaymentInfo.step === 1 && (
                    <PaymentHomePage
                        handlePaymentMethodChange={handlePaymentMethodChange}
                        setIsFeedbackModalOpen={setIsFeedbackModalOpen}
                        handleClose={handleClose} />
                )}

                {openPaymentInfo.step === 2 && (
                    <PaymentBalancePage
                        handleBack={handleBack}
                        currency={currency}
                        setPaymentAmount={setPaymentAmount}
                        setCurrency={setCurrency} />
                )}

                {openPaymentInfo.step === 3 && (
                    <PaymentConfirmPage
                        handleClose={handleClose}
                        currency={currency}
                        paymentAmount={paymentAmount} />
                )}

                {openPaymentInfo.step === 4 && <PaymentSuccessPage handleClose={handleClose} />}

                {openPaymentInfo.step === 5 && <CodeRedeemPage handleClose={handleClose} />}
            </div>
        </div>
    )
}))

export default RechargePopup;
